import React, { useEffect, useState } from 'react'
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';
import TableVerticalAlternative from './TableVerticalAlternative';
import { startRegisterCompareResult } from '../../app/actions/compareResultActions';

const ComparisonContainerAlternativeByField = () => {

  debugLogPages(':: ComparisonContainerAlternativeByField');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { alternativesS } = useSelector((state) => state.alternative);

  const { listFieldsAlternative } = useSelector((state) => state.moduleConfig);
  const { comparisonAlternativeComboEnabled } = useSelector((state) => state.configuration);
  const [listFieldsToCompare, setListFieldsToCompare] = useState();
  const [selectedField, setSelectedField] = useState()

  useEffect(() => {
    let listFieldsToCompareT = [];
    listFieldsAlternative.forEach(element => {
      
      if (element.is_comparable) {
        
        listFieldsToCompareT.push(element);
      }
    });
    setListFieldsToCompare(listFieldsToCompareT);
  }, [])

  const handleChangeSelectCompare = (event) => {

    if (event != null) {
      setSelectedField(event);

      let selectedIds = "";
      let countIds = 0;
      for (let index = 0; index < alternativesS.length; index++) {
        if (alternativesS[index].isSelected) {
          alternativesS[index].isCompared = true;

          if (countIds === 0) {
              selectedIds = selectedIds.concat(alternativesS[index].id);
            } else {
              selectedIds = selectedIds.concat(";", alternativesS[index].id);
            }

            countIds++;

        }else{
          alternativesS[index].isCompared = false;
        }
      }

      const objectCompare = {
        deleted:false,
        compare_ids:selectedIds,
        total_selected:countIds,
        selected_field:event.field,
        is_compare_all_fields:false
      }
      dispatch(startRegisterCompareResult(objectCompare));


    } else {
      setSelectedField(null);
    }
  };


  return (
    <div>

      <div className="flexbox-title">
         <h2>{t("general.compare-alternative")}</h2>
      </div>

      <br />

      {
        comparisonAlternativeComboEnabled === "true" &&
        <div>
          <Select
            myFontSize="14px"
            onChange={(event) => handleChangeSelectCompare(event)}
            className={`basic-single form-control`}
            classNamePrefix="select"
            name="texto"
            options={listFieldsToCompare}
            getOptionLabel={(option) => t(`${option.module_text}.synthetic.${option.field}`)}
            getOptionValue={(option) => `${option}`}
            isClearable={true}
            isSearchable={true}
            placeholder="Seleccione un Campo para comparar"
          />

          {selectedField && selectedField.field &&
            (<TableVerticalAlternative selectedField={selectedField} data={alternativesS} />)
          }

        </div>
      }

      <br />

    </div>
  )
}

export default ComparisonContainerAlternativeByField